module.exports = __webpack_public_path__ + "static/img/SallyCapp.181d147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SallyCapp.jpg
// module id = UYhT
// module chunks = 0